/**
 * @fileoverview VAT utility helpers for fraction/percent conversions and formatting.
 * @module shared/utils/vat
 */

/**
 * Convert a VAT rate expressed as a fraction (e.g., 0.23) to a whole-number percent (e.g., 23).
 * @param rateFraction VAT rate as a fraction between 0 and 1.
 * @returns Whole-number percent rounded to nearest integer.
 * @example
 * toVatPercent(0.23) // 23
 */
export function toVatPercent(rateFraction: number): number {
  return Math.round(rateFraction * 100)
}

/**
 * Format a VAT rate expressed as a fraction (e.g., 0.23) to a display string (e.g., "23%").
 * @param rateFraction VAT rate as a fraction between 0 and 1.
 * @returns A formatted percent string like "23%".
 * @example
 * formatVatPercent(0.19) // "19%"
 */
export function formatVatPercent(rateFraction: number): string {
  return `${toVatPercent(rateFraction)}%`
}
